import { Button, CircularProgress, Grid, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import MainCard from "ui-component/cards/MainCard";
import ChangePassword from "./changePassword";
import {
    IconListCheck,
    IconMap2,
    IconMessage,
    IconPasswordUser,
    IconShieldLock
} from "@tabler/icons-react";
import { useTheme } from "@mui/system";
import SubCard from "ui-component/cards/SubCard";
import Chip from "ui-component/extended/Chip";
import { getProfile } from "store/app/authentication/login/actions";
import { closeChangePasswordModal, openChangePasswordModal } from "store/app/authentication/change-password/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";

const UserProfile = (props) => {
    const { userProfile, isChangePasswordModal, isPending, errorMessage } = props;
    const { displayName, email, firstName, isActive, isEnabled, lastName, mobileNumber, userRoleName } = userProfile || {};
    const { states, regions } = userProfile || [];

    const theme = useTheme();

    useEffect(() => {
        props.getUserProfile();
    }, [])

    const openChangePasswordDialog = () => {
        props.openChangePasswordModal();
    }

    const handleClose = () => {
        props.closeChangePasswordModal();
    }

    return (
        <Grid container>
            <Grid item md={12}>
                <SubCard sx={{ p: 1.5, pl: 2 }}>
                    <Typography variant="h4">User Profile</Typography>
                </SubCard>
            </Grid>
            {errorMessage &&
                <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                    <ErrorAlert content={errorMessage} />
                </Grid>
            }
            {isPending ?
                <Grid container alignItems={"center"} justifyContent={"center"} gap={1}>
                    <CircularProgress />
                    <Typography variant="h5" color={'primary'}> Loading...</Typography>
                </Grid>
                :
                <>
                    <Grid item md={6} sx={{ overflow: "auto" }}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconListCheck color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Basic Info
                                </Typography>
                            </Grid>
                            <TableContainer sx={{ pl: 3, whiteSpace: "nowrap" }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>First Name</TableCell>
                                            <TableCell>{firstName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Last Name</TableCell>
                                            <TableCell>{lastName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Display Name</TableCell>
                                            <TableCell>{displayName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Role</TableCell>
                                            <TableCell>{userRoleName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Active Status</TableCell>
                                            <TableCell>{isActive ?
                                                <Chip label="Active" chipcolor="success" size="small" />
                                                : <Chip label="Inactive" chipcolor="error" size="small" />
                                            }</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Account Status</TableCell>
                                            <TableCell>{isEnabled ? <Chip label="Enabled" chipcolor="success" size="small" />
                                                : <Chip label="Disabled" chipcolor="error" size="small" />}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                    </Grid>
                    <Grid md={6} sx={{ overflow: "auto" }}>
                        <Grid item>
                            <MainCard sx={{ mt: 1, ml: { md: 1, lg: 1 } }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconMessage color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Communication Info
                                    </Typography>
                                </Grid>
                                <TableContainer sx={{ pl: 3, whiteSpace: "nowrap" }}>
                                    <Table size="small">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>Email Address</TableCell>
                                                <TableCell>{email || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Mobile Number</TableCell>
                                                <TableCell>{mobileNumber || "N/A"}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MainCard>
                        </Grid>
                        <Grid item sx={{ overflow: "auto" }}>
                            <MainCard sx={{ mt: 1, ml: { md: 1, lg: 1 } }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconShieldLock color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Change Password
                                    </Typography>
                                </Grid>
                                <Grid container sx={{ pl: 4, mt: 1 }} direction={'column'}>
                                    <Grid item>
                                        <Typography paragraph>
                                            Here you can change your password.
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={openChangePasswordDialog}
                                            startIcon={<IconPasswordUser />}
                                        >
                                            Change Password
                                        </Button>
                                        <ChangePassword
                                            open={isChangePasswordModal}
                                            email={email}
                                            onClose={handleClose}
                                        />
                                    </Grid>
                                </Grid>
                            </MainCard>
                        </Grid>
                    </Grid>
                    <Grid md={6} sx={{ overflow: "auto" }}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container alignItems={'center'} gap={1}>
                                <IconMap2 color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Assigned Regions Info
                                </Typography>
                            </Grid>
                            {
                                userRoleName !== "User" ?
                                    <Grid container sx={{ mt: 2 }}>
                                        <Typography variant="caption" sx={{ fontSize: "13px" }}>
                                            All regions are assigned automatically for this user.
                                        </Typography>
                                    </Grid>
                                    :
                                    regions?.length > 0 ?
                                        <Grid item sx={{ mt: 2, mb: 2, display: "flex", gap: "5px", overflow: "auto", flexWrap: "wrap", rowGap: "10px" }}>
                                            {regions?.map((region, idx) => (
                                                <Chip
                                                    key={idx}
                                                    chipcolor="orange"
                                                    label={
                                                        <Typography variant="h5" color="inherit">
                                                            {region.regionName}
                                                        </Typography>
                                                    }
                                                />
                                            ))}
                                        </Grid>
                                        : <Grid container>
                                            <Typography variant="caption" sx={{ fontSize: "13px", marginTop: "10px" }}>
                                                No region assigned to this user.
                                            </Typography>
                                        </Grid>
                            }
                        </MainCard>
                    </Grid>
                    <Grid md={6} sx={{ overflow: "auto" }}>
                        <MainCard sx={{ mt: 1, ml: { md: 1, lg: 1 } }}>
                            <Grid container alignItems={'center'} gap={1}>
                                <IconMap2 color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Assigned States/Exports Info
                                </Typography>
                            </Grid>
                            {
                                userRoleName !== "User" ?
                                    <Grid container sx={{ mt: 2 }}>
                                        <Typography variant="caption" sx={{ fontSize: "13px" }}>
                                            All states/exports are assigned automatically for this user.
                                        </Typography>
                                    </Grid>
                                    :
                                    states?.length > 0 ?
                                        <Grid item sx={{ mt: 2, mb: 2, display: "flex", gap: "5px", overflow: "auto", flexWrap: "wrap", rowGap: "10px" }}>
                                            {states?.map((state, idx) => (
                                                <Chip
                                                    key={idx}
                                                    chipcolor="orange"
                                                    label={
                                                        <Typography variant="h5" color="inherit">
                                                            {state.stateName}
                                                        </Typography>
                                                    }
                                                />
                                            ))}
                                        </Grid>
                                        : <Grid container>
                                            <Typography variant="caption" sx={{ fontSize: "13px", marginTop: "10px" }}>
                                                No state/Export assigned to this user.
                                            </Typography>
                                        </Grid>
                            }
                        </MainCard>
                    </Grid>
                </>
            }
        </Grid >

    )
}

const mapStateToProps = (state) => ({
    //------------------------Auth----------------------------
    isAuth: state.login.isAuth,
    //------------------------Change Password-----------------
    isChangePasswordModal: state.changePassword.isChangePasswordModal,
    //------------------------User Profile--------------------
    isPending: state.login.isProfilePending,
    userProfile: state.login.userProfile,
    errorMessage: state.login.profileErrorMessage,
})

const mapDispatchToProps = (dispatch) => ({
    //------------------------User Profile--------------------
    getUserProfile: () => dispatch(getProfile()),
    //------------------------Change Password-----------------
    openChangePasswordModal: () => dispatch(openChangePasswordModal()),
    closeChangePasswordModal: () => dispatch(closeChangePasswordModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);